import { csHttp } from "./http";

export const csMySubscription = (phone) =>
  csHttp.get("/api/me/subscription", { params: { phone } }).then((r) => r.data);
